import React from "react";
import { Button } from "antd";
import { ReloadOutlined, WifiOutlined } from "@ant-design/icons";
import * as Sentry from "@sentry/react";
import "./OfflinePage.scss";

interface OfflinePageProps {
  onRetry: () => void;
  isChecking?: boolean;
}

const OfflinePage: React.FC<OfflinePageProps> = ({ onRetry, isChecking }) => {
  const handleRetry = () => {
    Sentry.startSpan(
      {
        op: "ui.click",
        name: "Offline Page Retry",
      },
      () => {
        onRetry();
      },
    );
  };

  return (
    <div className="offline-page" role="alert" aria-live="assertive">
      <div className="offline-page__content">
        <div className="offline-page__icon" aria-hidden="true">
          <WifiOutlined />
          <span className="offline-page__icon-slash" />
        </div>
        <h1 className="offline-page__title">You&apos;re offline</h1>
        <p className="offline-page__message">
          ShopEG can&apos;t reach the internet right now. Please check your
          Wi-Fi or mobile data connection and try again.
        </p>
        <Button
          type="primary"
          size="large"
          icon={<ReloadOutlined />}
          loading={isChecking}
          onClick={handleRetry}
          className="offline-page__retry"
        >
          {isChecking ? "Checking..." : "Try again"}
        </Button>
        <p className="offline-page__hint">
          We&apos;ll reconnect you automatically once your connection is back.
        </p>
      </div>
    </div>
  );
};

export default OfflinePage;
